import $ from 'domtastic';
import anime from 'animejs';
import { events } from '../utils';

class NavigationDropdownMobile {
  constructor() {
    events.on('dropslideload', () => {
      this.cacheDom();
      this.bindEvents();
      this.animating = false;
    });
  }

  cacheDom() {
    this.$dropdownInvoker = $('.js-mobile-nav-dropdown-invoker');
    this.$dropdown = $('.js-mobile-nav-dropdown');
  }

  bindEvents() {
    this.$dropdownInvoker.off().on('click', (event) => {
      event.preventDefault();
      if (!this.animating) this.toggle(event.currentTarget);
    });
  }

  toggle(invoker) {
    const $invoker = $(invoker);
    const $dropdown = $invoker.parent().find('.js-mobile-nav-dropdown');
    const $content = $dropdown.find('.js-dropdown-content');
    const shouldOpen = !$dropdown.hasClass('-active');

    $dropdown.toggleClass('-active', shouldOpen);
    this.height = $content[0].offsetHeight;
    if (shouldOpen) return this.open($dropdown[0]);
    return this.close($dropdown[0]);
  }

  open(dropdown) {
    anime({
      targets: dropdown,
      height: `${this.height}`,
      duration: 400,
      easing: 'easeOutQuad',
      loop: false,
      begin: () => { this.animating = true; },
    })
    .finished.then(() => {
      this.animating = false;
    });
  }

  close(dropdown) {
    anime({
      targets: dropdown,
      height: '0',
      duration: 400,
      easing: 'easeOutQuad',
      loop: false,
      begin: () => { this.animating = true; },
    })
    .finished.then(() => {
      this.animating = false;
    });
  }
}

export default new NavigationDropdownMobile();



// WEBPACK FOOTER //
// ./components/NavigationDropdownMobile.js